import { useTranslations } from '@/hooks/useTranslations';
import type { InvoiceStatus as TInvoiceStatus } from '@/generated/prisma/client';

const STATUS_STYLES: Record<
  TInvoiceStatus,
  { dot: string; bg: string; border: string; key: string }
> = {
  PAID: {
    dot: 'bg-green-400',
    bg: 'bg-green-400/10',
    border: 'border-green-400',
    key: 'status.paid',
  },
  SENT: {
    dot: 'bg-blue-400',
    bg: 'bg-blue-400/10',
    border: 'border-blue-400',
    key: 'status.sent',
  },
  UNPAID: {
    dot: 'bg-amber-400',
    bg: 'bg-amber-400/10',
    border: 'border-amber-400',
    key: 'status.unpaid',
  },
  OVERDUE: {
    dot: 'bg-destructive',
    bg: 'bg-destructive/10',
    border: 'border-destructive-400',
    key: 'status.overdue',
  },
};

export const InvoiceStatus = ({ status }: { status: TInvoiceStatus }) => {
  const enums = useTranslations('Enums');
  const style = STATUS_STYLES[status] ?? STATUS_STYLES.UNPAID;

  return (
    <div className="flex">
      <div
        className={`flex justify-center items-center border px-3 py-0.5 rounded-full ${style.bg} ${style.border}`}
      >
        <span className={`${style.dot} w-2 h-2 rounded mr-1`} />
        <p>{enums(style.key)}</p>
      </div>
    </div>
  );
};
